/**
 * Generated by orval v6.11.1 🍺
 * Do not edit manually.
 * Blueprint: Client API
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useMutation
} from 'react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from 'react-query'
import type {
  PostOneSignalBodyDto,
  UpdatePlatformDtoV1,
  ActiveOptionalCommsDTO,
  AssignedAssesssmentDto,
  AssessmentsSubmittedDto,
  CheckInDtoV1,
  CheckInScoreResponseV1,
  CheckInControllerGetCheckInScoresParams,
  CheckInScoreBodyV1,
  SymptomIntervalDto,
  LifestyleGraphDto,
  WorksheetSummaryDto,
  HealthKitIOSStoreResponseV1,
  HealthKitIOSStoreBodyV1
} from './models'
import { coreApiInstance } from '../../axios-instance';
import type { ErrorType } from '../../axios-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const accountControllerPostOneSignalId = (
    postOneSignalBodyDto: PostOneSignalBodyDto,
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<void>(
      {url: `/v1/client-api/account/onesignal-id`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: postOneSignalBodyDto
    },
      options);
    }
  


    export type AccountControllerPostOneSignalIdMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerPostOneSignalId>>>
    export type AccountControllerPostOneSignalIdMutationBody = PostOneSignalBodyDto
    export type AccountControllerPostOneSignalIdMutationError = ErrorType<unknown>

    export const useAccountControllerPostOneSignalId = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerPostOneSignalId>>, TError,{data: PostOneSignalBodyDto}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerPostOneSignalId>>, {data: PostOneSignalBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  accountControllerPostOneSignalId(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof accountControllerPostOneSignalId>>, TError, {data: PostOneSignalBodyDto}, TContext>(mutationFn, mutationOptions);
    }
    
export const accountControllerPostUpdatePlatform = (
    updatePlatformDtoV1: UpdatePlatformDtoV1,
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<void>(
      {url: `/v1/client-api/account/platform`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: updatePlatformDtoV1
    },
      options);
    }
  


    export type AccountControllerPostUpdatePlatformMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerPostUpdatePlatform>>>
    export type AccountControllerPostUpdatePlatformMutationBody = UpdatePlatformDtoV1
    export type AccountControllerPostUpdatePlatformMutationError = ErrorType<unknown>

    export const useAccountControllerPostUpdatePlatform = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerPostUpdatePlatform>>, TError,{data: UpdatePlatformDtoV1}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerPostUpdatePlatform>>, {data: UpdatePlatformDtoV1}> = (props) => {
          const {data} = props ?? {};

          return  accountControllerPostUpdatePlatform(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof accountControllerPostUpdatePlatform>>, TError, {data: UpdatePlatformDtoV1}, TContext>(mutationFn, mutationOptions);
    }
    
export const accountControllerGetActiveOptionalComms = (
    
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<ActiveOptionalCommsDTO>(
      {url: `/v1/client-api/account/optional-comms`, method: 'get', signal
    },
      options);
    }
  

export const getAccountControllerGetActiveOptionalCommsQueryKey = () => [`/v1/client-api/account/optional-comms`];

    
export type AccountControllerGetActiveOptionalCommsQueryResult = NonNullable<Awaited<ReturnType<typeof accountControllerGetActiveOptionalComms>>>
export type AccountControllerGetActiveOptionalCommsQueryError = ErrorType<void>

export const useAccountControllerGetActiveOptionalComms = <TData = Awaited<ReturnType<typeof accountControllerGetActiveOptionalComms>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetActiveOptionalComms>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountControllerGetActiveOptionalCommsQueryKey();

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountControllerGetActiveOptionalComms>>> = ({ signal }) => accountControllerGetActiveOptionalComms(requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof accountControllerGetActiveOptionalComms>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const accountControllerUpdateActiveOptionalComms = (
    activeOptionalCommsDTO: ActiveOptionalCommsDTO,
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<void>(
      {url: `/v1/client-api/account/optional-comms`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: activeOptionalCommsDTO
    },
      options);
    }
  


    export type AccountControllerUpdateActiveOptionalCommsMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerUpdateActiveOptionalComms>>>
    export type AccountControllerUpdateActiveOptionalCommsMutationBody = ActiveOptionalCommsDTO
    export type AccountControllerUpdateActiveOptionalCommsMutationError = ErrorType<unknown>

    export const useAccountControllerUpdateActiveOptionalComms = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerUpdateActiveOptionalComms>>, TError,{data: ActiveOptionalCommsDTO}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerUpdateActiveOptionalComms>>, {data: ActiveOptionalCommsDTO}> = (props) => {
          const {data} = props ?? {};

          return  accountControllerUpdateActiveOptionalComms(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof accountControllerUpdateActiveOptionalComms>>, TError, {data: ActiveOptionalCommsDTO}, TContext>(mutationFn, mutationOptions);
    }
    
export const assessmentControllerGetAssessments = (
    
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<AssignedAssesssmentDto[]>(
      {url: `/client-api/assessments/assigned`, method: 'get', signal
    },
      options);
    }
  

export const getAssessmentControllerGetAssessmentsQueryKey = () => [`/client-api/assessments/assigned`];

    
export type AssessmentControllerGetAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof assessmentControllerGetAssessments>>>
export type AssessmentControllerGetAssessmentsQueryError = ErrorType<void>

export const useAssessmentControllerGetAssessments = <TData = Awaited<ReturnType<typeof assessmentControllerGetAssessments>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof assessmentControllerGetAssessments>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssessmentControllerGetAssessmentsQueryKey();

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof assessmentControllerGetAssessments>>> = ({ signal }) => assessmentControllerGetAssessments(requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof assessmentControllerGetAssessments>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const assessmentControllerSubmitAssessments = (
    
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<AssessmentsSubmittedDto>(
      {url: `/client-api/assessments/submit`, method: 'post'
    },
      options);
    }
  


    export type AssessmentControllerSubmitAssessmentsMutationResult = NonNullable<Awaited<ReturnType<typeof assessmentControllerSubmitAssessments>>>
    
    export type AssessmentControllerSubmitAssessmentsMutationError = ErrorType<void>

    export const useAssessmentControllerSubmitAssessments = <TError = ErrorType<void>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assessmentControllerSubmitAssessments>>, TError,TVariables, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assessmentControllerSubmitAssessments>>, TVariables> = () => {
          

          return  assessmentControllerSubmitAssessments(requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof assessmentControllerSubmitAssessments>>, TError, TVariables, TContext>(mutationFn, mutationOptions);
    }
    
export const checkInControllerGetCheckIns = (
    
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<CheckInDtoV1[]>(
      {url: `/v1/client-api/check-ins/assigned`, method: 'get', signal
    },
      options);
    }
  

export const getCheckInControllerGetCheckInsQueryKey = () => [`/v1/client-api/check-ins/assigned`];

    
export type CheckInControllerGetCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof checkInControllerGetCheckIns>>>
export type CheckInControllerGetCheckInsQueryError = ErrorType<void>

export const useCheckInControllerGetCheckIns = <TData = Awaited<ReturnType<typeof checkInControllerGetCheckIns>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkInControllerGetCheckIns>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckInControllerGetCheckInsQueryKey();

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkInControllerGetCheckIns>>> = ({ signal }) => checkInControllerGetCheckIns(requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof checkInControllerGetCheckIns>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const checkInControllerGetCheckIn = (
    id: string,
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<CheckInDtoV1>(
      {url: `/v1/client-api/check-ins/assigned/${id}`, method: 'get', signal
    },
      options);
    }
  

export const getCheckInControllerGetCheckInQueryKey = (id: string,) => [`/v1/client-api/check-ins/assigned/${id}`];

    
export type CheckInControllerGetCheckInQueryResult = NonNullable<Awaited<ReturnType<typeof checkInControllerGetCheckIn>>>
export type CheckInControllerGetCheckInQueryError = ErrorType<void>

export const useCheckInControllerGetCheckIn = <TData = Awaited<ReturnType<typeof checkInControllerGetCheckIn>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkInControllerGetCheckIn>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckInControllerGetCheckInQueryKey(id);

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkInControllerGetCheckIn>>> = ({ signal }) => checkInControllerGetCheckIn(id, requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof checkInControllerGetCheckIn>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const checkInControllerGetCheckInScores = (
    params: CheckInControllerGetCheckInScoresParams,
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<CheckInScoreResponseV1>(
      {url: `/v1/client-api/check-ins/scores`, method: 'get',
        params, signal
    },
      options);
    }
  

export const getCheckInControllerGetCheckInScoresQueryKey = (params: CheckInControllerGetCheckInScoresParams,) => [`/v1/client-api/check-ins/scores`, ...(params ? [params]: [])];

    
export type CheckInControllerGetCheckInScoresQueryResult = NonNullable<Awaited<ReturnType<typeof checkInControllerGetCheckInScores>>>
export type CheckInControllerGetCheckInScoresQueryError = ErrorType<void>

export const useCheckInControllerGetCheckInScores = <TData = Awaited<ReturnType<typeof checkInControllerGetCheckInScores>>, TError = ErrorType<void>>(
 params: CheckInControllerGetCheckInScoresParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkInControllerGetCheckInScores>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckInControllerGetCheckInScoresQueryKey(params);

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkInControllerGetCheckInScores>>> = ({ signal }) => checkInControllerGetCheckInScores(params, requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof checkInControllerGetCheckInScores>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const checkInControllerSubmit = (
    checkInScoreBodyV1: CheckInScoreBodyV1[],
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<void>(
      {url: `/v1/client-api/check-ins/submit`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: checkInScoreBodyV1
    },
      options);
    }
  


    export type CheckInControllerSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof checkInControllerSubmit>>>
    export type CheckInControllerSubmitMutationBody = CheckInScoreBodyV1[]
    export type CheckInControllerSubmitMutationError = ErrorType<unknown>

    export const useCheckInControllerSubmit = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkInControllerSubmit>>, TError,{data: CheckInScoreBodyV1[]}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkInControllerSubmit>>, {data: CheckInScoreBodyV1[]}> = (props) => {
          const {data} = props ?? {};

          return  checkInControllerSubmit(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof checkInControllerSubmit>>, TError, {data: CheckInScoreBodyV1[]}, TContext>(mutationFn, mutationOptions);
    }
    
export const insightsControllerGetSymptomGraph = (
    
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<SymptomIntervalDto[]>(
      {url: `/v1/client-api/insights/symptoms/graph`, method: 'get', signal
    },
      options);
    }
  

export const getInsightsControllerGetSymptomGraphQueryKey = () => [`/v1/client-api/insights/symptoms/graph`];

    
export type InsightsControllerGetSymptomGraphQueryResult = NonNullable<Awaited<ReturnType<typeof insightsControllerGetSymptomGraph>>>
export type InsightsControllerGetSymptomGraphQueryError = ErrorType<void>

export const useInsightsControllerGetSymptomGraph = <TData = Awaited<ReturnType<typeof insightsControllerGetSymptomGraph>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof insightsControllerGetSymptomGraph>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInsightsControllerGetSymptomGraphQueryKey();

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof insightsControllerGetSymptomGraph>>> = ({ signal }) => insightsControllerGetSymptomGraph(requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof insightsControllerGetSymptomGraph>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const insightsControllerGetLifestyleGraph = (
    
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<LifestyleGraphDto[]>(
      {url: `/v1/client-api/insights/lifestyle/graph`, method: 'get', signal
    },
      options);
    }
  

export const getInsightsControllerGetLifestyleGraphQueryKey = () => [`/v1/client-api/insights/lifestyle/graph`];

    
export type InsightsControllerGetLifestyleGraphQueryResult = NonNullable<Awaited<ReturnType<typeof insightsControllerGetLifestyleGraph>>>
export type InsightsControllerGetLifestyleGraphQueryError = ErrorType<void>

export const useInsightsControllerGetLifestyleGraph = <TData = Awaited<ReturnType<typeof insightsControllerGetLifestyleGraph>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof insightsControllerGetLifestyleGraph>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInsightsControllerGetLifestyleGraphQueryKey();

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof insightsControllerGetLifestyleGraph>>> = ({ signal }) => insightsControllerGetLifestyleGraph(requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof insightsControllerGetLifestyleGraph>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const insightsControllerGetWorksheetsSummary = (
    
 options?: SecondParameter<typeof coreApiInstance>,signal?: AbortSignal
) => {
      return coreApiInstance<WorksheetSummaryDto[]>(
      {url: `/v1/client-api/insights/worksheets/summary`, method: 'get', signal
    },
      options);
    }
  

export const getInsightsControllerGetWorksheetsSummaryQueryKey = () => [`/v1/client-api/insights/worksheets/summary`];

    
export type InsightsControllerGetWorksheetsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof insightsControllerGetWorksheetsSummary>>>
export type InsightsControllerGetWorksheetsSummaryQueryError = ErrorType<void>

export const useInsightsControllerGetWorksheetsSummary = <TData = Awaited<ReturnType<typeof insightsControllerGetWorksheetsSummary>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof insightsControllerGetWorksheetsSummary>>, TError, TData>, request?: SecondParameter<typeof coreApiInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInsightsControllerGetWorksheetsSummaryQueryKey();

  


  const queryFn: QueryFunction<Awaited<ReturnType<typeof insightsControllerGetWorksheetsSummary>>> = ({ signal }) => insightsControllerGetWorksheetsSummary(requestOptions, signal);


  

  const query = useQuery<Awaited<ReturnType<typeof insightsControllerGetWorksheetsSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const healthkitControllerV1PostIOSStore = (
    healthKitIOSStoreBodyV1: HealthKitIOSStoreBodyV1,
 options?: SecondParameter<typeof coreApiInstance>,) => {
      return coreApiInstance<HealthKitIOSStoreResponseV1>(
      {url: `/v1/client-api/health-kit/ios/store`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: healthKitIOSStoreBodyV1
    },
      options);
    }
  


    export type HealthkitControllerV1PostIOSStoreMutationResult = NonNullable<Awaited<ReturnType<typeof healthkitControllerV1PostIOSStore>>>
    export type HealthkitControllerV1PostIOSStoreMutationBody = HealthKitIOSStoreBodyV1
    export type HealthkitControllerV1PostIOSStoreMutationError = ErrorType<void>

    export const useHealthkitControllerV1PostIOSStore = <TError = ErrorType<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof healthkitControllerV1PostIOSStore>>, TError,{data: HealthKitIOSStoreBodyV1}, TContext>, request?: SecondParameter<typeof coreApiInstance>}
) => {
      const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof healthkitControllerV1PostIOSStore>>, {data: HealthKitIOSStoreBodyV1}> = (props) => {
          const {data} = props ?? {};

          return  healthkitControllerV1PostIOSStore(data,requestOptions)
        }

        

      return useMutation<Awaited<ReturnType<typeof healthkitControllerV1PostIOSStore>>, TError, {data: HealthKitIOSStoreBodyV1}, TContext>(mutationFn, mutationOptions);
    }
    
